import Vue from 'vue'
import { Scrollbar, Carousel, CarouselItem, Dialog, Table, TableColumn, Input, Form, FormItem, Select, Option, Switch, Message, DatePicker, Cascader, CheckboxGroup, Checkbox, RadioGroup, Radio, Loading, Button, Dropdown, DropdownItem, DropdownMenu, Tooltip, Pagination, Tabs, TabPane, Image, Calendar, Badge, ButtonGroup, Popover, Slider } from 'element-ui'
// Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.prototype.$message = Message
Vue.use(Scrollbar)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(ButtonGroup)
Vue.use(Badge)
Vue.use(Calendar)
Vue.use(Image)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Switch)
Vue.use(DatePicker)
Vue.use(Cascader)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Loading)
Vue.use(Button)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Popover)
Vue.use(Slider)
